import { request } from '@api/request'
import { DescargaVariablePDFRequestParamsDTO } from '@models/api/DescargaVariablePDFRequestParamsDTO'
import { showToastError } from '@services/ToastService'
import { newI18n } from 'src/i18n'

const { t } = newI18n.global

export const descargaVariablePDF = {
  get: async function (params: DescargaVariablePDFRequestParamsDTO) {
    try {
      return request.get<File | BlobPart>('api/descargaVariablePdf', {
        params: params,
        responseType: 'blob'
      })
    } catch (error) {
      showToastError(t('error'), t('downloadFailedError'))
    }
  }
}
